import { Check } from "lucide-react";
import AgencyContactForm from "./AgencyContactForm";

const BENEFITS = [
  "Konkretne uwagi o Twojej stronie",
  "Propozycję dopasowaną do Twojej firmy",
  "Jasną wycenę bez ukrytych kosztów",
];

export default function AgencyContact() {
  return (
    <section
      id="kontakt"
      data-testid="agency-contact"
      className="relative py-20 lg:py-28 border-t border-white/5 scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-yellow">
              Porozmawiajmy
            </div>
            <h2 className="mt-3 font-heading font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Chcesz więcej{" "}
              <span className="text-brand-yellow">klientów?</span>
            </h2>
            <p className="mt-5 text-base sm:text-lg text-white/65 max-w-md leading-relaxed">
              Zostaw kontakt — zadzwonimy i porozmawiamy o Twojej firmie.
              Bez zobowiązań.
            </p>

            <ul className="mt-10 space-y-4" data-testid="agency-contact-benefits">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="mt-0.5 grid place-items-center h-6 w-6 rounded-full bg-brand-yellow text-brand-yellowFg flex-shrink-0 shadow-sm">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <span className="text-[15.5px] text-white/85 leading-snug">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <AgencyContactForm />
        </div>
      </div>
    </section>
  );
}
